import { gql } from "@apollo/client";

export const GET_VM_BACKUP_HISTORY = gql`
  query GetVmBackupHistoryByDateRange($vmId: ID!, $startDate: String!, $endDate: String!) {
    getVmBackupHistoryByDateRange(vmId: $vmId, startDate: $startDate, endDate: $endDate) {
      vmId
      vmName
      startDate
      endDate
      disks {
        diskName
        protectionStatus
        vaultName
        dataSourceType
        backupHistory {
          date
          status
          duration
          startTime
        }
      }
    }
  }
`;

export const GET_ALL_BACKUP_VAULTS_WITH_ITEMS = gql`
  query GetAllBackupVaultsWithItems {
    getAllBackupVaultsWithItems {
      vaultName
      resourceGroup
      location
      storageType
      protectedItems {
        dataSourceName
        protectionStatus
        vmName
        vmId
        lastBackup {
          status
          startTime
          duration
        }
        backup30DaysAgo {
          status
          startTime
          duration
        }
      }
    }
  }
`;